// Original instrumental scores for Family Album; no third-party recordings or samples.
type Track = {
  id: string;
  title: string;
  bpm: number;
  transpose: number;
  chords: readonly (readonly number[])[];
  melody: readonly (readonly number[])[];
};

const TRACKS: readonly Track[] = [
  {
    id: 'afternoon', title: '햇살 머무는 오후', bpm: 68, transpose: 0,
    chords: [[48, 52, 55, 59], [45, 52, 55, 60], [41, 48, 52, 57], [43, 50, 55, 59]],
    melody: [[76, 0, 74, 72, 0, 67, 69, 0], [72, 0, 76, 0, 79, 76, 0, 74],
      [77, 0, 76, 72, 0, 69, 72, 0], [74, 0, 71, 0, 67, 0, 0, 0],
      [72, 76, 0, 79, 0, 76, 74, 0], [76, 0, 72, 0, 69, 72, 0, 0],
      [69, 0, 72, 77, 0, 76, 72, 0], [71, 0, 74, 0, 72, 0, 0, 0]],
  },
  {
    id: 'letter', title: '작은 편지', bpm: 64, transpose: 2,
    chords: [[48, 52, 55, 59], [43, 50, 55, 59], [45, 52, 55, 60], [41, 48, 52, 57]],
    melody: [[67, 0, 72, 0, 76, 74, 72, 0], [71, 0, 74, 0, 79, 0, 74, 0],
      [76, 0, 72, 69, 0, 67, 69, 0], [72, 0, 69, 0, 65, 0, 0, 0],
      [76, 0, 79, 76, 0, 74, 72, 0], [74, 0, 71, 67, 0, 71, 74, 0],
      [72, 0, 76, 0, 72, 69, 0, 0], [69, 0, 72, 0, 72, 0, 0, 0]],
  },
  {
    id: 'walk', title: '함께 걷는 길', bpm: 72, transpose: -5,
    chords: [[41, 48, 52, 57], [48, 52, 55, 59], [43, 50, 55, 59], [45, 52, 55, 60]],
    melody: [[72, 0, 77, 76, 0, 72, 69, 0], [67, 0, 72, 76, 0, 79, 76, 0],
      [74, 0, 79, 0, 77, 74, 71, 0], [72, 0, 76, 0, 72, 69, 0, 0],
      [77, 0, 76, 72, 0, 69, 72, 0], [76, 0, 74, 72, 0, 67, 72, 0],
      [71, 74, 0, 77, 0, 74, 71, 0], [72, 0, 69, 0, 72, 0, 0, 0]],
  },
  {
    id: 'window', title: '창가의 온기', bpm: 62, transpose: -2,
    chords: [[45, 52, 55, 60], [41, 48, 52, 57], [48, 52, 55, 59], [43, 50, 55, 59]],
    melody: [[76, 0, 0, 72, 0, 69, 72, 0], [77, 0, 76, 0, 72, 0, 69, 0],
      [67, 0, 72, 0, 76, 79, 0, 76], [74, 0, 71, 0, 67, 0, 0, 0],
      [72, 0, 76, 0, 81, 79, 76, 0], [77, 0, 72, 0, 69, 72, 0, 0],
      [76, 0, 74, 72, 0, 67, 72, 0], [74, 0, 71, 0, 72, 0, 0, 0]],
  },
  {
    id: 'home', title: '우리의 저녁', bpm: 66, transpose: 5,
    chords: [[48, 52, 55, 59], [41, 48, 52, 57], [45, 52, 55, 60], [43, 50, 55, 59]],
    melody: [[72, 0, 67, 0, 76, 74, 72, 0], [69, 0, 72, 0, 77, 76, 72, 0],
      [76, 0, 72, 69, 0, 72, 76, 0], [74, 0, 71, 0, 67, 0, 0, 0],
      [79, 0, 76, 0, 74, 72, 67, 0], [77, 0, 76, 72, 0, 69, 72, 0],
      [72, 0, 69, 0, 76, 0, 74, 0], [71, 0, 74, 0, 72, 0, 0, 0]],
  },
  {
    id: 'starlight', title: '별빛 자장가', bpm: 60, transpose: 0,
    chords: [[50, 57, 60, 65], [46, 53, 57, 62], [48, 55, 60, 64], [45, 52, 57, 60],
      [46, 53, 58, 62], [53, 57, 60, 65], [43, 50, 55, 58], [48, 55, 58, 64]],
    melody: [[77, 0, 81, 0, 79, 77, 0, 72], [74, 0, 77, 0, 81, 0, 77, 0],
      [76, 0, 79, 0, 84, 79, 0, 76], [72, 0, 76, 0, 69, 0, 0, 0],
      [74, 77, 0, 82, 0, 81, 77, 0], [81, 0, 77, 76, 0, 72, 0, 0],
      [74, 0, 79, 77, 0, 74, 0, 0], [76, 0, 72, 0, 77, 0, 0, 0]],
  },
  {
    id: 'picnic', title: '바람 따라 소풍', bpm: 78, transpose: 0,
    chords: [[43, 50, 55, 59], [50, 57, 60, 66], [40, 47, 52, 55], [48, 55, 59, 64],
      [45, 52, 55, 60], [50, 57, 60, 66], [47, 54, 59, 62], [43, 50, 55, 59]],
    melody: [[71, 74, 0, 79, 0, 74, 71, 0], [74, 0, 78, 0, 81, 78, 74, 0],
      [79, 0, 76, 74, 0, 71, 67, 0], [76, 0, 79, 83, 0, 79, 76, 0],
      [72, 0, 76, 79, 0, 76, 72, 0], [74, 78, 0, 81, 0, 78, 74, 0],
      [74, 0, 71, 0, 78, 0, 74, 0], [71, 0, 74, 0, 79, 0, 0, 0]],
  },
  {
    id: 'film', title: '추억이 흐르는 밤', bpm: 70, transpose: 0,
    chords: [[45, 52, 57, 60], [41, 48, 53, 57], [48, 55, 60, 64], [43, 50, 55, 59],
      [50, 57, 60, 65], [45, 52, 57, 60], [41, 48, 53, 57], [43, 50, 55, 62]],
    melody: [[76, 0, 81, 79, 0, 76, 72, 0], [77, 0, 81, 0, 84, 81, 77, 0],
      [79, 0, 76, 0, 72, 76, 79, 0], [74, 0, 71, 0, 67, 0, 0, 0],
      [77, 0, 81, 84, 0, 81, 77, 0], [76, 79, 0, 81, 0, 76, 72, 0],
      [77, 0, 76, 72, 0, 69, 72, 0], [74, 0, 79, 0, 76, 0, 0, 0]],
  },
];

const LAST_TRACK_KEY = 'family-album:slideshow:last-original-track';

export interface WarmMusicPlayer {
  resume: () => void;
  pause: () => void;
  stop: () => void;
  next: () => void;
}

export function createWarmMusicPlayer(onTrack: (title: string) => void): WarmMusicPlayer | null {
  const AudioContextClass = window.AudioContext ||
    (window as typeof window & { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!AudioContextClass) return null;
  const context = new AudioContextClass();
  const master = context.createGain();
  master.gain.value = 0.52;
  const filter = context.createBiquadFilter();
  filter.type = 'lowpass';
  filter.frequency.value = 4800;
  filter.Q.value = 0.4;
  master.connect(filter);
  const compressor = context.createDynamicsCompressor();
  compressor.threshold.value = -12;
  compressor.knee.value = 18;
  compressor.ratio.value = 3;
  compressor.attack.value = 0.01;
  compressor.release.value = 0.35;
  filter.connect(compressor);
  compressor.connect(context.destination);

  // A quiet, non-feedback room echo keeps the keyboard soft and clear.
  const delay = context.createDelay(1);
  delay.delayTime.value = 0.23;
  const room = context.createGain();
  room.gain.value = 0.12;
  filter.connect(delay);
  delay.connect(room);
  room.connect(compressor);

  const voices = new Set<AudioScheduledSourceNode>();
  let stopped = false;
  let paused = false;
  let step = 0;
  let nextTime = context.currentTime + 0.06;
  let lastId = '';
  try { lastId = window.localStorage.getItem(LAST_TRACK_KEY) || ''; } catch { /* Private browsing. */ }
  let queue: Track[] = [];
  let track: Track;

  const chooseTrack = () => {
    if (!queue.length) {
      queue = [...TRACKS];
      for (let i = queue.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        [queue[i], queue[j]] = [queue[j], queue[i]];
      }
      if (queue[0].id === lastId) [queue[0], queue[1]] = [queue[1], queue[0]];
    }
    track = queue.shift()!;
    lastId = track.id;
    try { window.localStorage.setItem(LAST_TRACK_KEY, lastId); } catch { /* Music still works. */ }
    step = 0;
    onTrack(track.title);
  };

  const note = (midi: number, time: number, duration: number, volume: number, timbre: 'piano' | 'guitar' | 'bell' = 'piano') => {
    const envelope = context.createGain();
    envelope.gain.setValueAtTime(0.0001, time);
    envelope.gain.exponentialRampToValueAtTime(volume, time + 0.012);
    envelope.gain.exponentialRampToValueAtTime(volume * 0.35, time + 0.18);
    envelope.gain.exponentialRampToValueAtTime(0.0001, time + duration);
    envelope.connect(master);
    // Decaying harmonics add a rounded piano-like attack without audio samples.
    const harmonics = timbre === 'guitar' ? [0.68, 0.22, 0.08, 0.02]
      : timbre === 'bell' ? [0.72, 0.05, 0.18, 0.05] : [0.76, 0.18, 0.06];
    let remaining = harmonics.length;
    harmonics.forEach((strength, index) => {
      const harmonic = index + 1;
      const oscillator = context.createOscillator();
      const level = context.createGain();
      oscillator.type = timbre === 'guitar' && index === 0 ? 'triangle' : 'sine';
      oscillator.frequency.value = 440 * 2 ** ((midi - 69) / 12) * harmonic;
      level.gain.value = strength;
      oscillator.connect(level);
      level.connect(envelope);
      voices.add(oscillator);
      oscillator.onended = () => {
        voices.delete(oscillator);
        oscillator.disconnect();
        level.disconnect();
        remaining -= 1;
        if (!remaining) envelope.disconnect();
      };
      oscillator.start(time);
      oscillator.stop(time + duration + 0.02);
    });
  };

  // Slow string-like chord beds and a soft shaker vary the arrangement by section.
  const pad = (midi: number, time: number, duration: number) => {
    const envelope = context.createGain();
    envelope.gain.setValueAtTime(0.0001, time);
    envelope.gain.linearRampToValueAtTime(0.009, time + 0.65);
    envelope.gain.setValueAtTime(0.009, time + duration * 0.65);
    envelope.gain.exponentialRampToValueAtTime(0.0001, time + duration);
    envelope.connect(master);
    let remaining = 2;
    [-4, 4].forEach((detune) => {
      const voice = context.createOscillator();
      voice.type = 'triangle';
      voice.frequency.value = 440 * 2 ** ((midi - 69) / 12);
      voice.detune.value = detune;
      voice.connect(envelope); voices.add(voice);
      voice.onended = () => {
        voices.delete(voice); voice.disconnect();
        if (--remaining === 0) envelope.disconnect();
      };
      voice.start(time); voice.stop(time + duration + 0.02);
    });
  };
  const noise = context.createBuffer(1, Math.ceil(context.sampleRate * 0.09), context.sampleRate);
  const noiseData = noise.getChannelData(0);
  for (let i = 0; i < noiseData.length; i += 1) noiseData[i] = Math.random() * 2 - 1;
  const shaker = (time: number, accent: boolean) => {
    const voice = context.createBufferSource(); voice.buffer = noise;
    const highpass = context.createBiquadFilter(); highpass.type = 'highpass'; highpass.frequency.value = 6500;
    const envelope = context.createGain();
    envelope.gain.setValueAtTime(accent ? 0.014 : 0.007, time);
    envelope.gain.exponentialRampToValueAtTime(0.0001, time + 0.085);
    voice.connect(highpass); highpass.connect(envelope); envelope.connect(master);
    voices.add(voice);
    voice.onended = () => { voices.delete(voice); voice.disconnect(); highpass.disconnect(); envelope.disconnect(); };
    voice.start(time); voice.stop(time + 0.09);
  };

  const clearVoices = () => {
    voices.forEach((voice) => { try { voice.stop(); } catch { /* Already ended. */ } });
    voices.clear();
  };

  const schedule = () => {
    if (stopped || paused || context.state !== 'running') return;
    if (nextTime < context.currentTime) nextTime = context.currentTime + 0.04;
    while (nextTime < context.currentTime + 0.2) {
      if (step === 256) chooseTrack(); // 32 bars, then a different piece.
      const halfBeat = 30 / track.bpm;
      const bar = Math.floor(step / 8);
      const slot = step % 8;
      const chord = track.chords[bar % track.chords.length];
      const section = Math.floor(bar / 8);
      const phrase = track.melody[bar % 8];
      const melody = phrase[slot];
      const soft = section === 2 ? 0.78 : 1;
      const timbre = ['walk', 'picnic'].includes(track.id) ? 'guitar'
        : ['letter', 'starlight'].includes(track.id) ? 'bell' : 'piano';
      if (slot === 0) chord.slice(1).forEach((pitch) => pad(pitch + track.transpose, nextTime, halfBeat * 8.8));
      if ((section === 1 || section === 3) && slot % 2 === 1) {
        note(chord[(slot + bar) % chord.length] + track.transpose + 12, nextTime + 0.012, halfBeat * 1.8, 0.027, 'guitar');
        if (!['window', 'starlight'].includes(track.id)) shaker(nextTime, slot === 3 || slot === 7);
      }
      if (section === 3 && !melody && (slot === 3 || slot === 7)) {
        note(chord[2] + track.transpose + 12, nextTime, halfBeat * 2.5, 0.026, 'bell');
      }
      if (slot === 0) note(chord[0] + track.transpose - 12, nextTime, halfBeat * 6, 0.075 * soft);
      if (slot % 2 === 0) {
        const arpeggio = chord[[1, 2, 3, 2][slot / 2]] + track.transpose;
        note(arpeggio, nextTime + 0.018, halfBeat * 3.2, 0.055 * soft, timbre);
      }
      if (melody) {
        const pitch = melody + track.transpose + (section === 2 ? -12 : 0);
        const end = phrase.slice(slot + 1).findIndex((value) => value !== 0);
        const length = end < 0 ? 8 - slot : end + 1;
        note(pitch, nextTime, halfBeat * Math.min(length + 0.6, 4), 0.105 * soft, timbre);
      }
      step += 1;
      nextTime += halfBeat;
    }
  };

  chooseTrack();
  const timer = window.setInterval(schedule, 80);
  return {
    resume() {
      if (stopped) return;
      paused = false;
      void context.resume().then(schedule).catch(() => { /* Retry on the next gesture. */ });
    },
    pause() {
      if (stopped) return;
      paused = true;
      void context.suspend().catch(() => {});
    },
    next() {
      if (stopped) return;
      clearVoices();
      chooseTrack();
      nextTime = context.currentTime + 0.06;
      schedule();
    },
    stop() {
      if (stopped) return;
      stopped = true;
      window.clearInterval(timer);
      clearVoices();
      void context.close().catch(() => {});
    },
  };
}
